var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-wrapper"},[_c(_vm.getLogo,{tag:"component",class:_vm.view})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }